<adapt-dialog [maxWidth]="800">
    <h3 adapt-dialog-title>Select Deep Dive Image</h3>

    <ng-container adapt-dialog-content>
        <dx-file-manager class="deep-dive-image-selector"
                         [fileSystemProvider]="fileSystemProvider"
                         (onSelectedFileOpened)="onSelectedFileOpened($event)"
                         (onSelectionChanged)="onSelectionChanged($event)"
                         [customizeDetailColumns]="customizeDetailColumns"
                         [allowedFileExtensions]="['.png', '.jpg', '.jpeg']"
                         height="100%"
                         selectionMode="single">
            <dxo-file-manager-upload [chunkSize]="maxAllowedFileSize"
                                     [maxFileSize]="maxAllowedFileSize"></dxo-file-manager-upload>
            <dxo-file-manager-permissions [create]="false"
                                          [copy]="false"
                                          [move]="false"
                                          [delete]="false"
                                          [rename]="false"
                                          [upload]="true"
                                          [download]="false"> </dxo-file-manager-permissions>
            <dxo-file-manager-item-view mode="thumbnails"
                                        [showParentFolder]="false"></dxo-file-manager-item-view>
        </dx-file-manager>
    </ng-container>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   saveText="Select & Close"
                                   [discardConfirmationInstance]="instance"></adapt-standard-dialog-buttons>
</adapt-dialog>
